import React, { ComponentProps } from 'react';
import { identifyComponent } from '../../../util';
import { useTableSortContext } from '../TableSortContext';
import { TableHeadCellBase } from './Base';
import { TableHeadCellLabel } from './Label';
import { TableHeadCellSortLabel } from './SortLabel';
import { TableHeadCellProps } from './types';

export function TableHeadCell<R>({
  column,
  className,
  textStyles = {},
  firstColumn,
  lastColumn,
  borders,
  fixed,
}: TableHeadCellProps<R>) {
  const { label, align, sortable, key, tooltip, initialSortDirection } = column;
  const { activeSortColumnKey, activeSortDirection, onSortChange } = useTableSortContext();

  function handleClick() {
    if (sortable) {
      onSortChange(key, initialSortDirection);
    }
  }

  /**
   * For the first column, position the tooltip to the right of the header,
   * for the middle columns, center it, for the last column position it
   * to the left of the header.
   */
  const tooltipProps: ComponentProps<typeof TableHeadCellLabel>['tooltipProps'] = {
    placement: firstColumn ? 'top-start' : lastColumn ? 'top-end' : 'top',
  };

  return (
    <TableHeadCellBase
      data-component="TableHeadCell"
      className={className}
      borders={borders}
      align={align}
      fixed={fixed}
      {...identifyComponent('table-head-cell')}
    >
      {label &&
        (sortable ? (
          <TableHeadCellSortLabel
            active={activeSortColumnKey === key}
            direction={activeSortDirection}
            initialDirection={initialSortDirection}
            onClick={handleClick}
            tooltip={tooltip}
            tooltipProps={tooltipProps}
            {...textStyles}
          >
            {label}
          </TableHeadCellSortLabel>
        ) : (
          <TableHeadCellLabel tooltip={tooltip} tooltipProps={tooltipProps} {...textStyles}>
            {label}
          </TableHeadCellLabel>
        ))}
    </TableHeadCellBase>
  );
}
